import {
  ORG_OPERATOR_ROLES,
  SYSTEM_ADMIN_ROLES,
  WEB_APP_ROLES,
  type Role,
} from '@eon/types';

/** Roles that may sign in to the unified web application. */
export const LOGIN_ROLES = WEB_APP_ROLES;

/** Platform admin surface (`/admin/*` hooks, full CSMS). */
export const ADMIN_SURFACE_ROLES = SYSTEM_ADMIN_ROLES;

/** Org operator portal surface (`/om/*` hooks, read-focused). */
export const PORTAL_SURFACE_ROLES = ORG_OPERATOR_ROLES;

/** Routes restricted to org operators (profile, notifications). */
export const PORTAL_ONLY_ROUTE_ROLES = ORG_OPERATOR_ROLES;

export function canAccessAdminSurface(role: Role | undefined | null): boolean {
  return ADMIN_SURFACE_ROLES.some((r) => r === role);
}

export function canAccessPortalSurface(role: Role | undefined | null): boolean {
  return PORTAL_SURFACE_ROLES.some((r) => r === role);
}
